/**
 * Nutrition-label popup for the editable product showcase.
 *
 * Deliberately plain: one delegated listener on document, no custom elements and no
 * import map. The theme editor re-renders section HTML on every setting change, which
 * detaches any listener bound to elements inside the section — delegation survives that.
 * The guard flag keeps a re-executed script from binding twice.
 */
(function () {
  if (window.__epsNutritionPopupReady) return;
  window.__epsNutritionPopupReady = true;

  /** Restores page scrolling once no popup is open. */
  function releaseScroll() {
    if (!document.querySelector('.eps-nutrition[open]')) {
      document.body.style.overflow = '';
    }
  }

  function openPopup(id) {
    const dialog = document.getElementById(id);
    if (!dialog || typeof dialog.showModal !== 'function' || dialog.open) return;

    dialog.showModal();
    document.body.style.overflow = 'hidden';
  }

  function closePopup(dialog) {
    if (!dialog || !dialog.open) return;
    dialog.close();
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-eps-popup-open]');
    if (trigger) {
      event.preventDefault();
      openPopup(trigger.getAttribute('data-eps-popup-open'));
      return;
    }

    const closer = event.target.closest('[data-eps-popup-close]');
    if (closer) {
      event.preventDefault();
      closePopup(closer.closest('.eps-nutrition'));
      return;
    }

    // Clicking the backdrop reports the dialog itself as the target, because the
    // backdrop is a pseudo-element rather than a real node. Anything inside the
    // card stops here, so only true backdrop clicks close the popup.
    const dialog = event.target.closest('.eps-nutrition');
    if (dialog && event.target === dialog) closePopup(dialog);
  });

  // Native <dialog> fires `close` for Escape too, so scroll is always restored.
  document.addEventListener('close', (event) => {
    if (event.target instanceof HTMLElement && event.target.classList.contains('eps-nutrition')) {
      releaseScroll();
    }
  }, true);
})();
